<template>
    <div class="flex justify-center">
        <el-tooltip
            :open-delay="200"
            effect="dark"
            :disabled="!assignedAndAvailableAgents.length"
            placement="top"
        >
            <template #content>
                <div>
                    <p
                        v-for="(agent, index) in assignedAndAvailableAgents"
                        :key="agent.user.UserID"
                        :class="{
                            'mb-1': index !== assignedAndAvailableAgents.length - 1
                        }"
                    >
                        {{ agent.userName }}
                    </p>
                </div>
            </template>

            <div class="px-2">
                {{ String(assignedAndAvailableAgents.length) }}
            </div>
        </el-tooltip>
    </div>
</template>

<script>
import { Tooltip } from 'element-ui'
import queueColumnMixin from '@/mixins/queueAgentsColumnMixin'

export default {
    mixins: [ queueColumnMixin ],
    components: {
        [Tooltip.name]: Tooltip,
    },
    computed: {
        /**
         * All the agents which are assigned to the queue and are available
         *
         * The agent is available if:
         * - The agent passed the availability check by calls
         * - The agent passed the availability check by status
         *
         * @returns {UserData[]}
         */
        assignedAndAvailableAgents () {
            // TODO RTD-695 wait for queueRule to be in extension event call object
            return Object.values(this.queueMembersMap).filter((member) => {
                return this.isQueueMemberAvailableByCalls(member) && this.isQueueMemberAvailableByStatus(member)
            })
        },
    },
}
</script>
